(function () {
  if (window.xjCountrySelectorInitialized) return;
  window.xjCountrySelectorInitialized = true;

  const REGIONS = {
  'EUROPE': [
    'AL','AD','AM','AT','AZ','BY','BE','BA','BG','HR',
    'CY','CZ','DK','EE','FI','FR','GE','DE','GR','HU',
    'IS','IE','IT','XK','LV','LI','LT','LU','MT','MD',
    'MC','ME','NL','MK','NO','PL','PT','RO','SM','RS',
    'SK','SI','ES','SE','CH','UA','GB','VA'
  ],

  'NORTH AMERICA': [
    'CA','US','MX','GT','BZ','HN','SV','NI','CR','PA',
    'CU','JM','HT','DO','PR','TT','BB','BS'
  ],

  'ASIA (COUNTRY/REGION)': [
    'AF','BD','BT','BN','KH','CN','HK','IN','ID','JP',
    'KZ','KG','LA','MO','MY','MV','MN','MM','NP','PK',
    'PH','SG','KR','LK','TW','TJ','TH','TL','TM','UZ','VN'
  ],

  'MIDDLE EAST': [
    'BH','IR','IQ','IL','JO','KW','LB','OM','PS','QA',
    'SA','SY','AE','YE'
  ],

  'SOUTH AMERICA': [
    'AR','BO','BR','CL','CO','EC','GY','PY','PE','SR','UY','VE'
  ],

  'AFRICA': [
    'DZ','AO','BJ','BW','BF','BI','CV','CM','CF','TD',
    'KM','CG','CD','CI','DJ','EG','GQ','ER','SZ','ET',
    'GA','GM','GH','GN','GW','KE','LS','LR','LY','MG',
    'MW','ML','MR','MU','MA','MZ','NA','NE','NG','RW',
    'ST','SN','SC','SL','SO','ZA','SS','SD','TZ','TG',
    'TN','UG','ZM','ZW'
  ],

  'OCEANIA': [
    'AU','FJ','KI','MH','FM','NR','NZ','PW','PG','WS',
    'SB','TO','TV','VU'
  ],

  'INTERNATIONAL SITE': []
};
function getRegion(isoCode) {
  const code = String(isoCode || '').toUpperCase();

  for (const [region, list] of Object.entries(REGIONS)) {
    if (list.includes(code)) {
      return region;
    }
  }

  return 'INTERNATIONAL SITE';
}

  function initCountrySelector(container) {
    if (!container) return;

    const dataId = container.dataset.countryDataId;
    const currentIso = container.dataset.currentIso;

    if (!dataId) return;

    const dataElement = document.getElementById(dataId);

    if (!dataElement) return;

    let countries = [];

    try {
      countries = JSON.parse(dataElement.textContent);
    } catch (error) {
      console.error('Xander Jane country data could not be parsed.', error);
      return;
    }

    const grouped = {};

    countries.forEach(country => {
  const region = getRegion(country.iso);

      if (!grouped[region]) {
        grouped[region] = [];
      }

      grouped[region].push(country);
    });

    container.innerHTML = '';

    let activeOptionNode = null;

    Object.keys(REGIONS).forEach(region => {
      const list = grouped[region];

      if (!list || list.length === 0) return;

      const hasActive = list.some(
        country => country.iso === currentIso
      );

      const group = document.createElement('div');

      group.className =
        'cl-region-group' +
        (hasActive ? ' is-open' : '');

      const header = document.createElement('button');

      header.type = 'button';
      header.className = 'cl-region-header';

      header.innerHTML =
        '<span>' +
        region +
        '</span>' +
        '<span class="cl-region-arrow">+</span>';

      header.addEventListener('click', function () {
        const wasOpen =
          group.classList.contains('is-open');

        container
          .querySelectorAll('.cl-region-group.is-open')
          .forEach(openGroup => {
            openGroup.classList.remove('is-open');
          });

        if (!wasOpen) {
          group.classList.add('is-open');
        }
      });

      const wrap = document.createElement('div');

      wrap.className = 'cl-region-countries-wrap';

      const listElement = document.createElement('ul');

      listElement.className = 'cl-region-countries';

      list.forEach(country => {
        const item = document.createElement('li');

        const button = document.createElement('button');

        button.type = 'button';
        button.dataset.iso = country.iso;
        button.textContent = country.name.toUpperCase();

        if (country.iso === currentIso) {
          button.className =
            'cl-region-option is-active';
        } else {
          button.className = 'cl-region-option';
        }

        button.addEventListener('click', function () {
          if (activeOptionNode) {
            activeOptionNode.classList.remove(
              'is-selected'
            );
          }

          this.classList.add('is-selected');

          activeOptionNode = this;

          const footer =
            container.closest('footer');

          const codeInput =
            footer?.querySelector(
              '#cl-selected-country-code'
            );

          const confirmButton =
            footer?.querySelector(
              '#cl-country-confirm'
            );

          if (codeInput) {
            codeInput.value = country.iso;
          }

          if (confirmButton) {
            confirmButton.disabled =
              country.iso === currentIso;
          }
        });

        item.appendChild(button);
        listElement.appendChild(item);
      });

      wrap.appendChild(listElement);

      group.appendChild(header);
      group.appendChild(wrap);

      container.appendChild(group);
    });
  }

  function initAllCountrySelectors(root) {
    const scope = root || document;

    scope
      .querySelectorAll('[data-xj-country-list]')
      .forEach(initCountrySelector);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initAllCountrySelectors(document);
      }
    );
  } else {
    initAllCountrySelectors(document);
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initAllCountrySelectors(event.target);
    }
  );
})();